module.exports = __webpack_public_path__ + "img/car-5.3673b3e2.jpg";